/**
 * =====================================================
 * ISOFIN® FEUCHTE-ANALYSE - CONTENT (DE)
 * =====================================================
 * 
 * Optimiert für Kapillarfeuchte-Erkennung.
 * Alle Texte zentral. Steps referenzieren nur Codes.
 * 
 * @version 2.0.0
 */

(function() {
  'use strict';

  window.FA_CONTENT = window.FA_CONTENT || {};

  window.FA_CONTENT.de = {

    // ===== META =====
    meta: {
      name: 'Feuchte-Analyse',
      lang: 'de',
      version: '2.0.0'
    },

    // ===== COMMON UI =====
    ui: {
      next: 'Weiter',
      back: 'Zurück',
      restart: 'Neu starten',
      progress: 'Frage {x} von {n}',
      help: 'Info',
      unsure: 'Unsicher',
      loading: 'Wird geladen...',
      error: 'Ein Fehler ist aufgetreten'
    },

    // ===== STEPS =====
    steps: {

      // ----- INTRO -----
      intro: {
        title: 'Feuchte-Analyse',
        lead: 'Beantworten Sie 8 kurze Fragen. Sie erhalten eine Einschätzung, welche Feuchteart am wahrscheinlichsten ist \u2013 und was Sie tun können.',
        start: 'Analyse starten',
        badge: 'Kostenlos \u2022 2 Minuten \u2022 Sofort Ergebnis'
      },

      // ============================================
      // Q1: AUSSCHLUSS-FRAGE - Freies Wasser
      // ============================================
      q1: {
        title: 'Tritt frei bewegliches Wasser aus?',
        question: 'Sehen Sie Tropfen, Rinnspuren oder fließendes Wasser? Bilden sich Wasserstellen oder Pfützen am Boden?',
        options: [
          {
            code: 'active_yes',
            label: 'Ja, Wasser tropft oder läuft sichtbar',
            help: 'Es ist frei bewegliches Wasser vorhanden.'
          },
          {
            code: 'active_no',
            label: 'Nein, die Wand ist nur feucht oder verfärbt',
            help: 'Die Oberfläche ist durchfeuchtet, aber ohne Tropfen oder Fließen.'
          }
        ]
      },

      // ============================================
      // Q2: EARLY-STAGE - Wie bemerkst du es?
      // ============================================
      q2: {
        title: 'Was war Ihr erstes Warnzeichen?',
        question: 'Was ist Ihnen als erstes aufgefallen?',
        options: [
          {
            code: 'smell_only',
            label: 'Muffiger Geruch, sonst kaum sichtbar',
            help: 'Es riecht modrig, aber optisch f\u00e4llt wenig auf.'
          },
          {
            code: 'cold_clammy',
            label: 'Wand f\u00fchlt sich kalt oder klamm an',
            help: 'Beim Ber\u00fchren wirkt die Stelle dauerhaft k\u00fchl oder feucht.'
          },
          {
            code: 'wont_dry',
            label: 'Stelle wird einfach nicht richtig trocken',
            help: 'Trotz L\u00fcften oder Heizen bleibt es feucht.'
          },
          {
            code: 'dark_permanent',
            label: 'Oberfl\u00e4che wirkt dauerhaft dunkel',
            help: 'Ein Bereich ist st\u00e4ndig dunkler als der Rest.'
          },
          {
            code: 'plaster_damage',
            label: 'Sichtbare Sch\u00e4den am Putz oder Anstrich',
            help: 'Putz br\u00f6ckelt, Farbe bl\u00e4ttert, Sch\u00e4den sichtbar.'
          },
          {
            code: 'unsure_perception',
            label: 'Unsicher',
            help: 'Kein Problem \u2013 die n\u00e4chsten Fragen kl\u00e4ren es meist.'
          }
        ]
      },

      // ============================================
      // Q3: VERLAUF - Wo sitzt es? (Kapillar-Signatur)
      // ============================================
      q3: {
        title: 'Wo ist es am stärksten?',
        question: 'Schauen Sie die Wand von unten nach oben an \u2013 wo ist es am deutlichsten?',
        options: [
          {
            code: 'bottom_band',
            label: 'Unten stärker, nach oben weniger',
            help: 'Der stärkste Bereich liegt nahe Boden/Sockel.'
          },
          {
            code: 'bottom_knee',
            label: 'Bis etwa Kniehöhe (ca. 30\u201380 cm)',
            help: 'Der betroffene Bereich endet ungefähr im unteren Wandbereich.'
          },
          {
            code: 'bottom_hip',
            label: 'Bis Hüfthöhe oder höher (ca. 80\u2013150 cm)',
            help: 'Der Bereich reicht deutlich über den Sockel hinaus.'
          },
          {
            code: 'middle_or_spot',
            label: 'Mitten in der Wand oder punktuell',
            help: 'Es sind einzelne Stellen/Hotspots sichtbar.'
          },
          {
            code: 'everywhere',
            label: 'Über große Flächen gleichmäßig / ganze Wand',
            help: 'Die Verteilung wirkt nicht klar von unten kommend.'
          }
        ]
      },

      // ============================================
      // Q4: SALZ / ABLAGERUNGEN - starker Marker
      // ============================================
      q4: {
        title: 'Gibt es mineralische R\u00fcckst\u00e4nde?',
        question: 'Sehen Sie wei\u00dfe, salzartige Ablagerungen auf der Oberfl\u00e4che?',
        options: [
          {
            code: 'mineral_powder',
            label: 'Ja, wei\u00dfe oder pulvrige Ablagerungen',
            help: 'Feine, helle Schicht auf der Wand oder am \u00dcbergang zum Boden.'
          },
          {
            code: 'mineral_crystal',
            label: 'Ja, kristallartige Ausbl\u00fchungen',
            help: 'Gr\u00f6bere, krustige oder nadelförmige Kristalle sichtbar.'
          },
          {
            code: 'mineral_no',
            label: 'Nein, keine mineralischen R\u00fcckst\u00e4nde',
            help: 'Keine wei\u00dfen Ablagerungen erkennbar.'
          },
          {
            code: 'mineral_unsure',
            label: 'Unsicher / kann ich nicht beurteilen',
            help: 'Wenn m\u00f6glich: Nahfoto sp\u00e4ter zur Best\u00e4tigung.'
          }
        ]
      },

      // ============================================
      // Q5: LAGE IM GEBÄUDE
      // ============================================
      q5: {
        title: 'Wo liegt die betroffene Wand?',
        question: 'In welchem Bereich des Gebäudes tritt es auf?',
        options: [
          { code: 'basement', label: 'Keller / unter Erdniveau', help: 'Erdberührter Bereich.' },
          { code: 'ground_floor', label: 'Erdgeschoss', help: 'Bodennahe Wandzone.' },
          { code: 'upper_floor', label: 'Obergeschoss / Innenwand ohne Erdkontakt', help: 'Kein direkter Erdbezug.' }
        ]
      },

      // ============================================
      // Q6: ZEIT / WETTER
      // ============================================
      q6: {
        title: 'Wann ist es am stärksten?',
        question: 'Gibt es einen Zusammenhang mit Wetter oder Zeit?',
        options: [
          { code: 'always', label: 'Dauerhaft (wochen-/monatelang)', help: 'Relativ konstant vorhanden.' },
          { code: 'after_rain', label: 'Deutlich stärker nach Regen', help: 'Verschlechtert sich nach Niederschlag.' },
          { code: 'humid_days', label: 'Vor allem an schwülen / feuchtwarmen Tagen', help: 'Tagesabhängig bei hoher Luftfeuchte.' },
          { code: 'sudden', label: 'Plötzlich aufgetreten (seit Tagen/Wochen)', help: 'Schneller Beginn ohne langen Vorlauf.' },
          { code: 'unsure_weather', label: 'Kann ich nicht sagen', help: 'Okay \u2013 wir werten andere Antworten stärker.' }
        ]
      },

      // ============================================
      // Q7: GEBÄUDEALTER
      // ============================================
      q7: {
        title: 'Wie alt ist das Gebäude?',
        question: 'Ungefähres Baujahr (Schätzung reicht).',
        options: [
          { code: 'pre_1930', label: 'Vor 1930', help: 'Altbau / sehr alt.' },
          { code: 'between_1930_1970', label: '1930\u20131970', help: 'Älterer Bestand.' },
          { code: 'between_1970_2000', label: '1970\u20132000', help: 'Moderner Bestand.' },
          { code: 'after_2000', label: 'Nach 2000', help: 'Neubau/neuere Bauweise.' },
          { code: 'unknown_age', label: 'Weiß ich nicht', help: 'Kein Problem.' }
        ]
      },

      // ============================================
      // Q8: WANDTYP / MATERIAL
      // ============================================
      q8: {
        title: 'Woraus besteht die Wand?',
        question: 'Falls Sie es wissen \u2013 welches Material ist verbaut?',
        options: [
          { code: 'brick', label: 'Ziegel / Klinker / Kalksandstein', help: 'Mauerwerk (klassisch).' },
          { code: 'natural_stone', label: 'Naturstein / Bruchstein', help: 'Unregelmäßiges Steinmauerwerk.' },
          { code: 'hollow_block', label: 'Hohlblock / Porenbeton', help: 'Steine mit Hohlkammern/porig.' },
          { code: 'concrete', label: 'Beton (gegossen / Stahlbeton)', help: 'Monolithisch gegossen.' },
          { code: 'unknown_material', label: 'Weiß ich nicht / verputzt', help: 'Okay \u2013 ist häufig so.' }
        ]
      }

    },

    // ===== ERGEBNISSE =====
    results: {

      // ===== KAPILLAR =====
      kapillar: {
        title: 'Sehr wahrscheinlich: aufsteigende Feuchtigkeit (kapillar)',
        summary: 'Die Antworten passen am st\u00e4rksten zu einem Muster, bei dem Feuchtigkeit aus dem Sockel-/Erdkontaktbereich in der Wand nach oben wandert. Das ist eine typische Ursache bei fehlender oder geschw\u00e4chter Horizontalsperre.',
        icon: '\uD83E\uDDF1',
        color: '#d97706',
        next: [
          'Sicherheits-Check: Machen Sie 3\u20135 Fotos (\u00dcbersicht, Nahaufnahme, Boden/Wand-\u00dcbergang). So k\u00f6nnen wir die Einsch\u00e4tzung best\u00e4tigen.',
          'Wenn Ausbl\u00fchungen/Salze sichtbar sind, ist das ein zus\u00e4tzlicher starker Marker f\u00fcr Feuchtetransport im Mauerwerk.',
          'Wenn der Schaden dauerhaft besteht (nicht nur wetter-/tagesabh\u00e4ngig), spricht das ebenfalls eher f\u00fcr eine Durchfeuchtung im Baustoff.',
          'N\u00e4chster Schritt: Wir sagen Ihnen, ob eine Horizontalsperre ausreicht oder ob zus\u00e4tzlich eine Innen-Fl\u00e4chensperre sinnvoll ist.'
        ],
        cta_primary: 'Fotos zur Best\u00e4tigung senden',
        cta_secondary: 'Kostenlose R\u00fcckfrage stellen'
      },

      // ===== KAPILLAR PLUS (Kapillar + seitliches Eindringen) =====
      kapillar_plus: {
        title: 'Wahrscheinlich: aufsteigende + seitlich eindringende Feuchtigkeit (kapillar)',
        summary: 'Die Antworten deuten darauf hin, dass neben einer aufsteigenden Durchfeuchtung auch Feuchtigkeit seitlich \u00fcber erdber\u00fchrte Bereiche einwirken kann. Mischbilder sind h\u00e4ufig \u2013 vor allem im Keller.',
        icon: '\uD83C\uDFE0',
        color: '#ea580c',
        next: [
          'Sicherheits-Check: Mit Fotos l\u00e4sst sich sehr gut unterscheiden, ob das Muster eher "von unten", "von au\u00dfen" oder beides ist.',
          'Wenn es nach Regen deutlich st\u00e4rker wird, ist seitlicher Eintrag wahrscheinlicher.',
          'Wenn es unabh\u00e4ngig vom Wetter dauerhaft ist, spricht das eher f\u00fcr einen dauerhaften Feuchtenachschub.',
          'N\u00e4chster Schritt: Wir geben Ihnen eine klare Empfehlung, ob (1) nur horizontal, (2) nur Fl\u00e4che oder (3) beides sinnvoll ist.'
        ],
        cta_primary: 'Fotos senden',
        cta_secondary: 'Kurze Beratung anfragen'
      },

      // ===== KONDENSAT =====
      kondensat: {
        title: 'Wahrscheinlich: Kondensat (Oberfl\u00e4chenfeuchte)',
        summary: 'Die Antworten passen eher zu Feuchtigkeit, die sich an der Oberfl\u00e4che bildet (z.\u00a0B. bei hoher Luftfeuchte und kalten Wandfl\u00e4chen), statt zu einer Durchfeuchtung aus dem Mauerwerk.',
        icon: '\uD83D\uDCA7',
        color: '#3b82f6',
        next: [
          'Pr\u00fcfung: Tritt es vor allem an schw\u00fclen Tagen auf und wird bei L\u00fcften/Heizen schnell besser, ist Kondensat naheliegend.',
          'Achte auf: fl\u00e4chige Feuchte ohne klaren "Sockel-Verlauf".',
          'Wenn Sie unsicher sind: Fotos helfen, Kondensat vs. Mauerwerksfeuchte sicherer zu trennen.',
          'N\u00e4chster Schritt: Wir geben Ihnen eine konkrete Checkliste (L\u00fcftung/Heizung/Abst\u00e4nde/Messpunkt), passend zu Ihrem Fall.'
        ],
        cta_primary: 'Fotos zur Kl\u00e4rung senden',
        cta_secondary: 'Mit Experte sprechen'
      },

      // ===== DRUCKWASSER / LEITUNG =====
      druckwasser: {
        title: 'Verdacht: Druckwasser oder Leitungsfeuchte \u2013 kein Fall zum Selbermachen',
        summary: 'Wenn Wasser sichtbar austritt, tropft oder sich Pf\u00fctzen bilden, ist das kein typischer Kapillarschaden \u2013 und hier reicht eine Online-Analyse nicht aus. Sprechen Sie zuerst mit unserem Experten f\u00fcr eine saubere Einsch\u00e4tzung, bevor Sie etwas kaufen oder abdichten. Die Beratung ist kostenlos & unverbindlich.',
        icon: '\u26A0\uFE0F',
        color: '#dc2626',
        next: [
          'Sofort-Check: Ist der Schaden pl\u00f6tzlich entstanden oder ver\u00e4ndert sich schnell, sollte ein Fachcheck priorisiert werden.',
          'Wenn m\u00f6glich: Quelle eingrenzen (z.\u00a0B. Leitungen/Anschl\u00fcsse/Au\u00dfenbereich) und Fotos mit Datum dokumentieren.',
          'Nach Regen beobachten: Wird es klar st\u00e4rker, kann \u00e4u\u00dfere Wasserlast eine Rolle spielen.',
          'N\u00e4chster Schritt: Wir ordnen mit Fotos ein, ob ein Fachbetrieb n\u00f6tig ist und welche Infos der Betrieb braucht.'
        ],
        cta_primary: 'Fotos an Experten senden',
        cta_secondary: 'R\u00fcckruf anfragen'
      },

      // ===== UNKLAR =====
      unklar: {
        title: 'Nicht eindeutig \u2013 Foto-Check empfohlen',
        summary: 'Die Antworten ergeben noch kein klares Muster. Das ist normal: Feuchtebilder k\u00f6nnen sich \u00fcberlagern \u2013 und f\u00fcr eine saubere Einsch\u00e4tzung reicht die Online-Analyse dann nicht aus. Mit Fotos oder im Gespr\u00e4ch grenzt unser Experte die Ursache schnell ein \u2013 kostenlos & unverbindlich.',
        icon: '\uD83D\uDD0D',
        color: '#6b7280',
        next: [
          'Bitte 3\u20135 Fotos senden: \u00dcbersicht der Wand, Nahaufnahme, Boden/Wand-\u00dcbergang, optional Au\u00dfenbereich.',
          'Wir sagen Ihnen, ob es eher (1) Mauerwerksfeuchte, (2) Kondensat, (3) seitlicher Eintrag oder (4) Leitung/Druck ist.',
          'Sie bekommen eine klare Empfehlung, was Sie als N\u00e4chstes tun sollten \u2013 ohne Rate-Spiel.',
          'N\u00e4chster Schritt: Foto-Check \u2192 dann Entscheidung.'
        ],
        cta_primary: 'Fotos senden',
        cta_secondary: 'Mit Experte sprechen'
      }
    },

    // ===== CONFIDENCE LABELS =====
    confidence: {
      high: {
        label: 'Hohe Sicherheit',
        sublabel: 'Die Antworten ergeben ein klares Bild.',
        color: '#059669',
        icon: '\u2714'
      },
      medium: {
        label: 'Voraussichtlich kapillar',
        sublabel: 'Es handelt sich voraussichtlich um kapillare Feuchtigkeit.',
        color: '#059669',
        icon: '\u2714'
      },
      low: {
        label: 'Voraussichtlich kapillar',
        sublabel: 'Es kann nicht zu 100% von kapillarer Feuchtigkeit ausgegangen werden \u2014 bitte wenden Sie sich an unseren Experten.',
        color: '#d97706',
        icon: '~'
      }
    },

    // =====================================================
    // V2 STEPS — Dynamischer Diagnose-Flow
    // =====================================================
    stepsV2: {

      // v2q1: Gibt es aktives Wasser?
      v2q1: {
        qId: 'v2q1',
        title: 'Gibt es aktives Wasser?',
        subtitle: 'Tropft, flie\u00dft oder steht Wasser an der betroffenen Stelle?',
        options: [
          { id: 'active_yes', label: 'Ja', sub: 'Wasser tropft, flie\u00dft oder bildet Pf\u00fctzen', icon: '\uD83D\uDCA7' },
          { id: 'active_no', label: 'Nein', sub: 'Die Wand ist feucht, verfärbt oder riecht \u2014 aber kein flie\u00dfendes Wasser', icon: '\u2705' }
        ]
      },

      // v2q2: Wie verläuft der Schaden optisch?
      v2q2: {
        qId: 'v2q2',
        title: 'Wie sieht der Schaden an der Wand aus?',
        subtitle: 'W\u00e4hlen Sie das Muster, das am ehesten zutrifft.',
        options: [
          { id: 'unten_weniger', label: 'Unten st\u00e4rker', sub: 'Nach oben wird es weniger', icon: '\u2B07\uFE0F' },
          { id: 'kniehoehe', label: 'Bis Knieh\u00f6he', sub: 'Ca. 30\u201380 cm vom Boden', icon: '\uD83E\uDDB5' },
          { id: 'huefthoehe', label: 'Bis H\u00fcfth\u00f6he oder h\u00f6her', sub: 'Ca. 80\u2013150 cm vom Boden', icon: '\uD83D\uDC64' },
          { id: 'seitlich_ecke', label: 'Von einer Seite / Ecke', sub: 'Eher von au\u00dfen oder einer Ecke kommend', icon: '\u27A1\uFE0F' },
          { id: 'punktuell', label: 'Punktuell', sub: 'An einem Anschluss, \u00dcbergang oder einer bestimmten Stelle', icon: '\uD83D\uDCCD' },
          { id: 'grossflaechig', label: 'Gro\u00dffl\u00e4chig gleichm\u00e4\u00dfig', sub: 'Keine klare Richtung erkennbar', icon: '\u2B1C' },
          { id: 'unsure_pattern', label: 'Unsicher', sub: 'Kann ich nicht einsch\u00e4tzen', icon: '\u2753' }
        ]
      },

      // v2q3: Wo liegt die betroffene Wand?
      v2q3: {
        qId: 'v2q3',
        title: 'Wo befindet sich die betroffene Wand?',
        subtitle: 'Die Lage gibt Hinweise auf die wahrscheinliche Ursache.',
        options: [
          { id: 'keller', label: 'Keller', sub: 'Unter Erdniveau / Untergeschoss', icon: '\u2B07\uFE0F' },
          { id: 'eg', label: 'Erdgeschoss', sub: 'Ebenerdig / Parterre', icon: '\uD83C\uDFE0' },
          { id: 'og', label: 'Obergeschoss', sub: 'Ohne direkten Erdkontakt', icon: '\u2B06\uFE0F' },
          { id: 'hanglage', label: 'Hanglage', sub: 'Teilweise unter Erdreich', icon: '\u26F0\uFE0F' },
          { id: 'unsicher', label: 'Unsicher', sub: 'Kann ich nicht sicher sagen', icon: '\u2753' }
        ]
      },

      // v2q4: Zeitliches Verhalten
      v2q4: {
        qId: 'v2q4',
        title: 'Wie verh\u00e4lt sich die Feuchtigkeit zeitlich?',
        subtitle: 'Das zeitliche Muster hilft bei der Unterscheidung der Ursache.',
        options: [
          { id: 'dauerhaft', label: 'Dauerhaft vorhanden', sub: 'Seit Wochen oder Monaten', icon: '\u23F3' },
          { id: 'nach_regen', label: 'Nach Regen st\u00e4rker', sub: 'Bei trockenem Wetter besser', icon: '\uD83C\uDF27\uFE0F' },
          { id: 'schwuel', label: 'An schw\u00fclen Tagen st\u00e4rker', sub: 'Im Sommer / bei hoher Luftfeuchte', icon: '\uD83C\uDF21\uFE0F' },
          { id: 'ploetzlich', label: 'Pl\u00f6tzlich aufgetreten', sub: 'Innerhalb weniger Tage', icon: '\u26A1' },
          { id: 'unsicher_zeit', label: 'Unsicher', sub: 'Kann ich nicht beurteilen', icon: '\u2753' }
        ]
      },

      // v2q5: Ausblühungen / Ablagerungen
      v2q5: {
        qId: 'v2q5',
        title: 'Gibt es Ausbl\u00fchungen oder Ablagerungen?',
        subtitle: 'Wei\u00dfe Flecken oder kristalline R\u00fcckst\u00e4nde sind ein starkes Signal f\u00fcr kapillare Feuchtigkeit.',
        options: [
          { id: 'pulvrig', label: 'Ja, pulvrig / wei\u00dflich', sub: 'Feines wei\u00dfes Pulver auf der Oberfl\u00e4che', icon: '\u2744\uFE0F' },
          { id: 'kristall', label: 'Ja, kristallartig', sub: 'Gr\u00f6bere, kristalline Ausbl\u00fchungen', icon: '\uD83D\uDC8E' },
          { id: 'nein', label: 'Nein', sub: 'Keine sichtbaren Ablagerungen', icon: '\u274C' },
          { id: 'unsicher_salz', label: 'Unsicher', sub: 'Kann ich nicht beurteilen', icon: '\u2753' }
        ]
      },

      // v2q6: Vereinfachte Wahrnehmung (optional)
      v2q6: {
        qId: 'v2q6',
        title: 'Was trifft zus\u00e4tzlich am ehesten zu?',
        subtitle: 'Eine letzte Einsch\u00e4tzung hilft uns bei der Bewertung.',
        options: [
          { id: 'trocknet_nicht', label: 'Stelle trocknet nicht richtig ab', sub: 'Trotz L\u00fcften bleibt die Stelle feucht', icon: '\uD83D\uDCA7' },
          { id: 'putz_loest', label: 'Putz / Farbe l\u00f6st sich', sub: 'Sichtbare Oberfl\u00e4chensch\u00e4den', icon: '\uD83E\uDDF1' },
          { id: 'klamm_muffig', label: 'Wand wirkt nur klamm / muffig', sub: 'Kein klarer Schaden sichtbar', icon: '\uD83D\uDCA8' },
          { id: 'unsicher_wahr', label: 'Unsicher', sub: 'Keines trifft zu', icon: '\u2753' }
        ]
      },

      // v2k1: Keller — Wo sitzt die Feuchte?
      v2k1: {
        qId: 'v2k1',
        title: 'Wo sitzt die Feuchte am st\u00e4rksten?',
        subtitle: 'Die genaue Position im Keller hilft bei der Einordnung.',
        options: [
          { id: 'aussenwand', label: 'An einer Au\u00dfenwand', sub: 'Zur Erde hin', icon: '\uD83C\uDFD7\uFE0F' },
          { id: 'ecke', label: 'In einer Ecke', sub: 'Wo zwei W\u00e4nde aufeinandertreffen', icon: '\uD83D\uDD32' },
          { id: 'boden_wand', label: 'Am \u00dcbergang Boden/Wand', sub: 'Unterer Wandbereich', icon: '\u2B07\uFE0F' },
          { id: 'innenwand', label: 'An Innenwand / Trennwand', sub: 'Ohne direkten Erdkontakt', icon: '\uD83D\uDEAA' },
          { id: 'anschluss', label: 'An Anschluss', sub: 'Treppe, Anbau, Lichtschacht', icon: '\uD83D\uDD17' },
          { id: 'unsicher_k1', label: 'Unsicher', sub: 'Kann ich nicht sagen', icon: '\u2753' }
        ]
      },

      // v2k2: Keller — Angrenzender Eintrittsbereich
      v2k2: {
        qId: 'v2k2',
        title: 'Gibt es einen angrenzenden Eintrittsbereich?',
        subtitle: 'Manche Kellerbereiche haben typische Schwachstellen.',
        options: [
          { id: 'lichtschacht', label: 'Lichtschacht', sub: 'Kellerfenster mit Schacht', icon: '\uD83D\uDD33' },
          { id: 'treppe', label: 'Treppe / Kellerhals', sub: 'Zugang von au\u00dfen', icon: '\uD83E\uDE9C' },
          { id: 'nachbar', label: 'Nachbarhaus / Nebengebäude', sub: 'Angrenzende Bebauung', icon: '\uD83C\uDFD8\uFE0F' },
          { id: 'grundstueck', label: 'Grundst\u00fccksmauer', sub: 'Begrenzung zum Nachbargrundst\u00fcck', icon: '\uD83E\uDDF1' },
          { id: 'keine_bes', label: 'Keine erkennbare Besonderheit', sub: 'Nichts davon trifft zu', icon: '\u2796' },
          { id: 'unsicher_k2', label: 'Unsicher', sub: 'Kann ich nicht beurteilen', icon: '\u2753' }
        ]
      },

      // v2k3: Keller — Erdberührt?
      v2k3: {
        qId: 'v2k3',
        title: 'Ist die Wand von au\u00dfen erdber\u00fchrt?',
        subtitle: 'Liegt die Wand direkt am Erdreich oder an einem Hang?',
        options: [
          { id: 'ja', label: 'Ja', sub: 'Die Wand grenzt direkt an Erde', icon: '\u2705' },
          { id: 'nein_k3', label: 'Nein', sub: 'Frei stehend / nicht erdber\u00fchrt', icon: '\u274C' },
          { id: 'teilweise', label: 'Teilweise', sub: 'Nur ein Teil ist erdber\u00fchrt', icon: '\u2796' },
          { id: 'unsicher_k3', label: 'Unsicher', sub: 'Kann ich nicht beurteilen', icon: '\u2753' }
        ]
      },

      // v2k4: Keller — Flächig oder lokal?
      v2k4: {
        qId: 'v2k4',
        title: 'Ist der Schaden eher fl\u00e4chig oder lokal begrenzt?',
        subtitle: 'Die Ausdehnung gibt Hinweise auf die Art des Eintritts.',
        options: [
          { id: 'flaechig', label: 'Fl\u00e4chig', sub: 'Gro\u00dfer Bereich betroffen', icon: '\u2B1C' },
          { id: 'lokal', label: 'Lokal begrenzt', sub: 'Nur eine bestimmte Stelle', icon: '\uD83D\uDCCD' },
          { id: 'wechselt', label: 'Wechselt', sub: 'Mal mehr, mal weniger Fl\u00e4che', icon: '\uD83D\uDD04' },
          { id: 'unsicher_k4', label: 'Unsicher', sub: 'Kann ich nicht beurteilen', icon: '\u2753' }
        ]
      }
    },

    // V2 Ergebnistexte
    resultsV2: {
      kapillar_aufsteigend: {
        title: 'Wahrscheinlich aufsteigende Feuchtigkeit (kapillar)',
        sub: 'Wasser steigt aus dem Fundament durch die Poren im Mauerwerk auf.',
        action: 'Isofin\u00ae bildet eine horizontale Sperre und stoppt den kapillaren Aufstieg.',
        confidence_high: 'Sehr wahrscheinlich kapillar \u2014 klassisches Muster.',
        confidence_medium: 'Wahrscheinlich kapillar \u2014 einige Merkmale passen.'
      },
      kapillar_lateral: {
        title: 'Wahrscheinlich seitlich eindringende Feuchtigkeit (kapillar)',
        sub: 'Feuchtigkeit dringt seitlich durch erdber\u00fchrte Wandbereiche ein.',
        action: 'Isofin\u00ae bildet eine Fl\u00e4chensperre und stoppt den seitlichen kapillaren Transport.',
        confidence_high: 'Sehr wahrscheinlich lateraler kapillarer Eintrag.',
        confidence_medium: 'Wahrscheinlich seitlicher Eintrag \u2014 einige Merkmale passen.'
      },
      kondensat: {
        title: 'Eher Kondensat / Raumklima',
        sub: 'Die Feuchtigkeit entsteht wahrscheinlich durch Kondensation an k\u00fchlen Wandoberfl\u00e4chen.',
        action: 'Empfehlung: L\u00fcftungsverhalten pr\u00fcfen, ggf. Entfeuchtung einsetzen.'
      },
      druckwasser: {
        title: 'Eher Druckwasser / akuter Wassereintritt',
        sub: 'Es liegt wahrscheinlich ein aktiver Wassereintritt vor, der eine andere Abdichtung erfordert.',
        action: 'Empfehlung: Fachliche Pr\u00fcfung vor Ort empfohlen.'
      },
      leitung: {
        title: 'Leitungsverdacht',
        sub: 'Der pl\u00f6tzliche Schaden deutet auf einen Rohrbruch oder Leitungsschaden hin.',
        action: 'Empfehlung: Installateur oder Leckortung kontaktieren.'
      },
      unklar: {
        title: 'Keine eindeutige Zuordnung m\u00f6glich',
        sub: 'Die Anzeichen lassen keine sichere Diagnose zu. Eine fachliche Pr\u00fcfung vor Ort ist empfohlen.',
        action: 'Unser Experte Hendrik hilft Ihnen kostenlos weiter.'
      }
    },

    // Produktfit-Phase (nach Diagnose, vor Wall-Wizard)
    produktfit: {
      p1: {
        title: 'Aus welchem Material ist Ihre Wand?',
        subtitle: 'Das Material beeinflusst Bohrabstand und Verbrauch.',
        options: [
          { id: 'brick', label: 'Ziegel / Klinker / Kalksandstein', icon: '\uD83E\uDDF1' },
          { id: 'natural_stone', label: 'Naturstein / Bruchstein', icon: '\u26F0\uFE0F' },
          { id: 'hollow_block', label: 'Hohlblock / Porenbeton', icon: '\uD83D\uDDBC\uFE0F' },
          { id: 'concrete', label: 'Beton', icon: '\u2B1C' },
          { id: 'unknown_material', label: 'Unbekannt / verputzt', icon: '\u2753' }
        ]
      },
      p2: {
        title: 'Gibt es eine besondere Bauweise?',
        subtitle: 'Sonderkonstruktionen k\u00f6nnen die Anwendung beeinflussen.',
        options: [
          { id: 'fachwerk', label: 'Fachwerkwand', icon: '\uD83C\uDFDA\uFE0F' },
          { id: 'doppelschalig', label: 'Doppelschaliges Mauerwerk', icon: '\uD83E\uDDF1' },
          { id: 'innenwand', label: 'Reine Innenwand', icon: '\uD83D\uDEAA' },
          { id: 'betonwand', label: 'Betonwand', icon: '\u2B1C' },
          { id: 'keine_bes', label: 'Keine Besonderheit', icon: '\u2705' },
          { id: 'unsicher_p2', label: 'Unsicher', icon: '\u2753' }
        ]
      }
    },

    // ===== UPLOAD / CTA =====
    upload: {
      title: 'Fotos senden',
      lead: 'Senden Sie uns 3\u20135 Fotos (Übersicht + Nahaufnahme + Boden/Wand-Übergang). Unser Experte Hendrik meldet sich mit einer Einschätzung.',
      tips: [
        'Foto 1: Übersicht (ganze Wand sichtbar)',
        'Foto 2\u20133: Nahaufnahme der feuchten Stelle',
        'Foto 4: Boden/Wand-Übergang',
        'Foto 5: Optional \u2013 Außenbereich/Umgebung'
      ],
      button: 'Fotos jetzt senden',
      whatsapp: 'Per WhatsApp senden',
      email: 'Per E-Mail senden'
    }

  };

})();
